export enum TemplateStep {
  FIRST_TOUCH = 'FirstTouch',
  SECOND_TOUCH = 'SecondTouch',
  FOLLOW_UP = 'FollowUp',
  LAST_TOUCH = 'LastTouch',
}
